import { PM_PROVIDERS } from 'common/constants/constants';
import DateCell from '../../../../../ResourceAllocationOverview/JiraStats/useTableRows/cell-components/DateCell';
import { PROGRESSION_MODEL, PROGRESSION_TABLE_MODEL } from './model';
import ProgressionCell from './cell-components/ProgressionCell';
import ParentCell from './cell-components/ParentCell';
import StatusCell from './cell-components/StatusCell';
import TextCell from './cell-components/TextCell';
import LinkToProviderCell from './cell-components/LinkToProviderCell';

const getCommonCells = row => {
  const lastActivity = row?.[PROGRESSION_MODEL.LAST_ACTIVITY];

  return {
    [PROGRESSION_TABLE_MODEL.LAST_ACTIVITY_CELL]: (
      <DateCell date={lastActivity} />
    )
  };
};

const getCommonJiraCells = row => {
  const key = row?.[PROGRESSION_MODEL.KEY];
  const title = row?.[PROGRESSION_MODEL.TITLE];
  const url = row?.[PROGRESSION_MODEL.URL];

  return {
    ...getCommonCells(row),
    [PROGRESSION_TABLE_MODEL.KEY_CELL]: (
      <LinkToProviderCell title={key} url={url} />
    ),
    [PROGRESSION_TABLE_MODEL.TITLE_CELL]: <TextCell text={title} />
  };
};

const getCommonAzureCells = row => {
  const title = row?.[PROGRESSION_MODEL.TITLE];
  const url = row?.[PROGRESSION_MODEL.URL];

  return {
    ...getCommonCells(row),
    [PROGRESSION_TABLE_MODEL.TITLE_CELL]: (
      <LinkToProviderCell title={title} url={url} />
    )
  };
};

export const mapRowToProviderCommonCells = row => ({
  [PM_PROVIDERS.JIRA]: getCommonJiraCells(row),
  [PM_PROVIDERS.AZURE_BOARDS]: getCommonAzureCells(row)
});

export const PROGRESSION_CELLS = {
  PROGRESS: row => {
    const progress = row?.[PROGRESSION_MODEL.PROGRESS];
    return {
      [PROGRESSION_TABLE_MODEL.PROGRESS_CELL]: (
        <ProgressionCell progress={progress} />
      )
    };
  },
  PARENT: row => {
    const parent = row?.[PROGRESSION_MODEL.PARENT];
    return {
      [PROGRESSION_TABLE_MODEL.PARENT_CELL]: <ParentCell parent={parent} />
    };
  },
  STATUS: row => {
    const statusKey = row?.[PROGRESSION_MODEL.STATUS];
    return {
      [PROGRESSION_TABLE_MODEL.STATUS_CELL]: (
        <StatusCell statusKey={statusKey} />
      )
    };
  }
};
